import { csrfToken, SuccessSwal, SwalPost } from "../../app";

$(function () {
  const body = $("body");

  if (body.hasClass("session-list")) {
    const table = $("#sessionsTable");
    const form = $("#sessionsFilterForm");

    table.DataTable({
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
      rowCallback: function (nRow, aData) {
        $(nRow).find("td:last-of-type").append(`
          <button data-session-key="${aData["session_key"]}" class="endUserSession btn btn-sm btn-danger">
            Sessiyanı kəs
          </button>
        `);
      },
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
    });

    $(".closeAllSessions").on("click", (e) => {
      e.preventDefault();
      const url = $(e.currentTarget).attr("href");
      SwalPost(
        url,
        {},
        {
          text: "Bütün sessiyaları kəsmək istədiyinizdən əminsinizmi? Belə ki, bütün istifadəçilər sistemə yenidən giriş etməli olacaqlar.",
          icon: "warning",
        },
      ).then((response) => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          window.location.href = String(response["redirect_url"]);
        });
      });
    });

    $(document).on("click", ".endUserSession", (e) => {
      e.preventDefault();
      const sessionKey = $(e.currentTarget).data("session-key");
      const url = sessionKey + "/delete/";
      SwalPost(
        url,
        {},
        {
          text: "Sessiyanı kəsmək istədiyinizdən əminsinizmi?",
          icon: "warning",
        },
      ).then((response) => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          if (response["redirect_url"]) {
            window.location.href = String(response["redirect_url"]);
          } else {
            table.DataTable().ajax.reload();
          }
        });
      });
    });

    const select2 = $("select[name=user_id]");
    select2.select2({
      ajax: {
        url: select2.attr("data-post-url"),
        type: "POST",
        dataType: "json",
        delay: 250,
        data: function (params) {
          return {
            csrfmiddlewaretoken: csrfToken,
            action: "select2",
            search: params.term,
            page: params.page || 1,
          };
        },
      },
    });
  }
});
